/**
 * @module ol/webgl/ContextEventType
 */

/**
 * @enum {string}
 */
export default {
  LOST: 'webglcontextlost',
  RESTORED: 'webglcontextrestored',
};
